<template>
  <b-overlay :show="searchingConfig">
    <form data-vv-scope="flow-part-1">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Datos para el flujo</h4>
          <span
            v-if="!isGore &&
             (wizardData.fileCategory === 'numInt' ||
             wizardData.fileCategory === 'numOf')"
          >
            Este expediente
            <span v-if="wizardData.fileCategory === 'numInt'">
              podrá tener numeración interna
            </span>
            <span v-if="wizardData.fileCategory === 'numOf'">
              podrá ser tramitado por Oficina de Partes
            </span>
          </span>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <vs-input
            class="w-100"
            label="Nombre para el flujo (*)"
            maxlength="120"
            name="name"
            v-model="step.name"
            :danger="errors.has('flow-part-1.name')"
            :danger-text="errors.first('flow-part-1.name')"
            v-validate="'required'"
          />
        </div>
        <div class="col-md-6">
          <vs-input
            class="w-100"
            label="Resumen (*)"
            name="description"
            v-model="step.description"
            :danger="errors.has('flow-part-1.description')"
            :danger-text="errors.first('flow-part-1.description')"
            v-validate="'required'"
            maxlength="550"
          />
        </div>
      </div>
      <div class="row mb-3" v-if="!step.oldFlow">
        <div class="col-md-6 mt-3">
          <BooleanParameter
            :is-approval-sign="true"
            param-id="aprobaciones.firmas.ubicacion"
            v-model="step.setSignaturePosition"
            @input="onSetSignaturePositionChange"
            data-cy="set-signature-position"
          />
        </div>
        <div class="col-md-6 mt-3">
          <div class="row">
            <div class="col-md-8 d-flex align-items-end">
              <label>Flujo privado</label>
              <InfoPrivateFlow />
            </div>
            <div class="col-md-2">
              <vs-radio
                vs-name="private"
                :vs-value="true"
                v-model="step.private"
                data-cy="privateYes"
              >
                Si
              </vs-radio>
            </div>
            <div class="col-md-2">
              <vs-radio
                vs-name="private"
                :vs-value="false"
                v-model="step.private"
                data-cy="privateNo"
              >
                No
              </vs-radio>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-8 d-flex align-items-end">
              <label>Estampar aprobaciones</label>
              <InfoApprovalStamp/>
            </div>
            <div class="col-md-2">
              <vs-radio
                vs-name="pdfStamp"
                :vs-value="true"
                v-model="step.pdfStamp"
                data-cy="pdfStampYes"
              >
                Si
              </vs-radio>
            </div>
            <div class="col-md-2">
              <vs-radio
                vs-name="pdfStamp"
                :vs-value="false"
                v-model="step.pdfStamp"
                data-cy="pdfStampNo"
              >
                No
              </vs-radio>
            </div>
          </div>
        </div>
        <div class="col-md-6" />
      </div>
    </form>
    <form data-vv-scope="flow-part-2">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Detalle del flujo</h4>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-3">
          <vs-select
            class="w-100"
            autocomplete
            label="Tipo de paso (*)"
            name="stepType"
            v-model="stepType"
            :danger="errors.has('flow-part-2.stepType')"
            :danger-text="errors.first('flow-part-2.stepType')"
            v-validate="'required'"
            @change="searchOffice"
          >
            <vs-select-item
              :value="stepTypes.USER"
              text="Usuario"
            />
            <vs-select-item
              v-if="wizardData.fileCategory !== 'int'"
              :value="stepTypes.OFFICE"
              text="Oficina"
            />
          </vs-select>
        </div>
        <div
          class="col-6"
          v-if="stepType === this.stepTypes.OFFICE"
        >
          <list-offices
            class="w-100 mb-1"
            autocomplete
            label="Oficina del responsable (*)"
            name="groupStep"
            v-model="groupStep"
            data-vv-as="oficina"
            :typeList="stepType"
            validate-lider
            withFilters
            :officeType="wizardData.fileCategory"
            :filterMyOffices="filterUserOffices"
            ref="groupStep"
            :danger="errors.has('flow-part-2.groupStep')"
            :danger-text="errors.first('flow-part-2.groupStep')"
            v-validate="{ required: stepType === this.stepTypes.OFFICE }"
          />
          <small class="text-danger">
            Si le falta una oficina, favor notificar al equipo de Soporte
            para que verifiquen que esté correctamente configurada
          </small>
        </div>
        <div
          class="col-6"
          v-if="stepType === stepTypes.USER"
        >
          <list-user
            class="w-100"
            autocomplete
            label="Usuario (*)"
            name="userStep"
            withFilters
            v-model="userStep"
            ref="userStep"
            :danger="errors.has('flow-part-2.userStep')"
            :danger-text="errors.first('flow-part-2.userStep')"
            v-validate="{ required: stepType === stepTypes.USER }"
          />
        </div>
        <div class="col-3" v-if="stepType !== stepTypes.OFFICE">
          <b-form-group
            label="Tipo de rol (*)"
          >
            <v-select
              id="rolType"
              label="label"
              :options="rolTypesOption"
              :reduce="rol => rol.id"
              name="rolType"
              v-model="rolType"
              :class="{ danger: errors.has('flow-part-2.rolType') }"
              v-validate="'required'"
            />
           <InfoRolType/>
            <span
              v-show="errors.has('flow-part-2.rolType')"
              class="danger span-text-validation-danger v-enter-to"
            >
              {{ errors.first('flow-part-2.rolType') }}
            </span>
          </b-form-group>
        </div>
        <div class="col-3" v-if="stepType === stepTypes.OFFICE">
          <b-form-group
            label="Tipo de rol (*)"
          >
            <v-select
              label="label"
              :options="rolTypesOfficeOption"
              :reduce="rol => rol.id"
              name="rolType"
              v-model="rolType"
              :class="{ danger: errors.has('flow-part-2.rolType') }"
              v-validate="'required'"
            />
            <div class="text-right">
              info
              <b-button
                size="sm"
                class="btn-icon rounded-circle mt-1"
                id="popover-button-default"
                variant="flat-primary"
              >
                <feather-icon icon="InfoIcon" />
              </b-button>
              <b-popover
                target="popover-button-default"
                triggers="focus"
                placement="top"
              >
                <template #title>
                  <span>Tipos de roles!</span>
                </template>
                <span>
                  <b>+ Numerar/tramitar:</b> Permite firmar documentos, esto cuenta como la
                  aprobación, se coloca un estampado de numeración o trámite.
                </span>
              </b-popover>
            </div>
            <span
              v-show="errors.has('flow-part-2.rolType')"
              class="danger span-text-validation-danger v-enter-to"
            >
              {{ errors.first('flow-part-2.rolType') }}
            </span>
          </b-form-group>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 d-flex align-items-end justify-content-end">
          <vs-button
            color="primary"
            icon="add"
            :disabled="blockButton"
            v-on:click="addStep()"
            data-cy="add-step"
          >
            Agregar Paso
          </vs-button>
        </div>
      </div>
      <div class="row mb-3" v-if="step.steps.length">
        <div
          class="col-3"
          v-for="(step, index) in step.steps" :key="`step-${index}`"
        >
          <div class="step-wrapper">
            <span class="step-number">{{step.stepNumber}}</span>
            <span class="step-delete">
              <vs-icon
                icon="highlight_off"
                size="small"
                bg="white"
                round
                @click="removeStep(step)"
              />
            </span>
            <div class="text-center step-name">
              {{ step.responsibleName }}
            </div>
            <div class="step-type">
              <span v-if="step.stepType === stepTypes.USER">
                usuario
              </span>
              <span v-if="step.stepType === stepTypes.OFFICE">
                oficina
              </span>
            </div>
            <div class="step-rol">
              <span v-if="step.rolType === rolTypes.APPROVER">
                aprobador
              </span>
              <span v-if="step.stepType !== stepTypes.OFFICE && step.rolType === rolTypes.SIGNER">
                firmante
              </span>
              <span v-if="step.rolType === rolTypes.REVIEWER">
                revisor
              </span>
              <span v-if="step.stepType === stepTypes.OFFICE && step.rolType === rolTypes.SIGNER">
                num/tramitar
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="error.message !== ''" class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to text-right"
           style="height: 32px;">
          <span class="span-text-validation">
            {{error.message}}
          </span>
      </div>
      <div v-if="showDistribution">
        <b-button
          v-b-modal="'modal-subjects'"
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          :variant="wizardData.haveSubjects ?
           'outline-success': isDistributionRequired ?
            'outline-warning': 'outline-info'"
          class="btn-icon shadow-lg mt-4"
          data-cy="btn-destinations"
        >
          Distribución
          <feather-icon icon="UsersIcon" />
        </b-button>
        <UpdateSubjectsFile
          :wizard="wizard"
          :document-id="wizardData.documentId"
          :participants="wizardData.subjects"
          @file-updated="markFileUpdated"
        />
      </div>
    </form>
  </b-overlay>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import ListOffices from '@/febos/chile/lists/components/ListOffices';
import ListUser from '@/febos/chile/lists/components/ListUser';
import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import BooleanParameter from '@/febos/chile/tools/components/BooleanParameter';
import { getSheetsConfig } from '@/febos/servicios/api/dnt.api';
import { listOptions } from '@/febos/servicios/api/opciones.api';
import InfoApprovalStamp from '@/febos/chile/approvals/wizardFlow/components/InfoApprovalStamp';
import InfoRolType from '@/febos/chile/approvals/wizardFlow/components/InfoRolType';
import InfoPrivateFlow from '@/febos/chile/approvals/wizardFlow/components/InfoPrivateFlow';
import UpdateSubjectsFile from '@/febos/chile/dnt/components/wizard/flow/UpdateSubjectsFile';
import {GORE_VALPARAISO, INH} from '@/constants/companies';

export default {
  name: 'StepFlow',
  mixins: [WizardStep],
  components: {
    InfoPrivateFlow,
    InfoRolType,
    InfoApprovalStamp,
    UpdateSubjectsFile,
    BooleanParameter,
    ListUser,
    ListOffices
  },
  data() {
    return {
      error: {
        message: ''
      },
      rolTypesOption: [
        { id: RolTypes.APPROVER, label: 'Aprobador' },
        { id: RolTypes.REVIEWER, label: 'Revisor' },
        { id: RolTypes.SIGNER, label: 'Firmante' }
      ],
      rolTypes: RolTypes,
      stepTypes: StepTypes,
      step: {
        haveSubjects: false,
        fileMime: 'application/pdf',
        fileDate: Vue.moment().format('YYYY-MM-DD HH:mm:ss'),
        fileId: this.$route.params.id,
        name: '',
        description: '',
        pdfStamp: true,
        steps: [],
        file: '',
        setSignaturePosition: false,
        signaturesDropped: {},
        mainFile: {
          name: '',
          path: ''
        },
        ...this.draft
      },
      stepType: StepTypes.USER,
      rolType: '',
      groupStep: '',
      userStep: '',
      blockButton: false,
      searchingConfig: false
    };
  },
  props: {
    wizard: { required: false }
  },
  watch: {
    wizardData(newValue) {
      this.step.name = newValue.fileResumen;
      this.step.haveSubjects = newValue.haveSubjects;
      this.step.private = this.step.private || newValue.fileApproach === '2' || newValue.fileApproach === 2;
      this.removeSignaturesDropped();
      if (this.wizardData.documentValue === 'OFCORE') {
        this.step.name = this.wizardData.fileName;
        this.step.description = this.wizardData.matter;
      }
    }
  },
  computed: {
    ...mapGetters('List', [
      'groupUsersState',
      'userGroupsState'
    ]),
    ...mapGetters('Dnts', [
      'wizardData',
      'documents'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Management', [
      'workerData'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('List', [
      'officesState'
    ]),
    isGore() {
      return this.company.iut === GORE_VALPARAISO.iut;
    },
    isInh() {
      return this.company.iut === INH.iut;
    },
    showDistribution() {
      return (this.isGore || this.isInh) && this.wizardData.origin;
    },
    isDistributionRequired() {
      return this.showDistribution
        && this.step.steps.some((step) => step.stepType === StepTypes.OFFICE);
    },
    rolTypesOfficeOption() {
      if ((this.isGore || this.isInh)
        && (this.wizardData.documentTypeName.toLowerCase().includes('memo')
          || this.wizardData.documentName.toLowerCase().includes('memo'))) {
        return [
          { id: RolTypes.APPROVER, label: 'Aprobador' }
        ];
      }
      return [
        { id: RolTypes.SIGNER, label: 'Numerar/Tramitar' }
      ];
    },
    filterUserOffices() {
      return this.wizardData.fileCategory === 'numInt' && (this.isGore || this.isInh);
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchUserGroups'
    ]),
    ...mapActions('Dnts', [
      'saveDocumentsList',
      'setDocumentInfo'
    ]),
    ...mapActions('Management', [
      'getWorkerData',
    ]),
    ...mapActions('Approvals', [
      'removeSignaturesDropped'
    ]),
    markFileUpdated() {
      this.step.haveSubjects = true;
    },
    clearValidation() {
      this.blockButton = false;
    },
    searchOffice() {
      this.clearValidation();
      if (this.stepType === StepTypes.OFFICE) {
        const typeOffice = this.wizardData.fileCategory === 'numOf' ? 'ext' : 'int';
        this.groupStep = typeOffice === 'ext'
          ? this.workerData.oficina_ext?.valor || ''
          : this.workerData.oficina_int?.valor || '';
      }
    },
    removeStep(stepRemove) {
      this.blockButton = false;
      this.error.message = '';
      this.step.steps = this.step.steps
        .filter((step) => step.stepNumber !== stepRemove.stepNumber)
        .map((stepMap, index) => ({
          ...stepMap,
          stepNumber: index + 1
        }));
    },
    async addStep() {
      this.error.message = '';
      this.blockButton = true;
      const isValid = await this.validateForm('flow-part-2');
      if (!isValid) {
        this.blockButton = false;
        return;
      }

      if (this.step.steps.find((step) => step.stepType === StepTypes.OFFICE)) {
        this.error.message = 'Oops! El último paso debe ser la oficina y ya la agregaste';
        return;
      }

      const responsibleStep = (
        this.stepType === StepTypes.GROUP || this.stepType === StepTypes.OFFICE
      )
        ? this.$refs.groupStep?.getOption()
        : this.$refs.userStep?.getOption();

      const step = {
        stepType: this.stepType,
        rolType: this.rolType,
        stepNumber: this.step.steps.length + 1,
        responsibleName: responsibleStep.label,
        responsibleId: responsibleStep.id,
        responsibleEmail: responsibleStep.email || '',
        ...((this.stepType === StepTypes.OFFICE && (this.isGore || this.isInh) && responsibleStep.type === 'int')
          && { disregarded: true }
        ),
        page: null,
        x: null,
        y: null
      };

      this.step.steps.push(step);

      this.stepType = this.stepTypes.USER;
      this.rolType = '';
      this.groupStep = '';
      this.userStep = '';
      this.blockButton = false;
      await this.$validator.reset();
    },
    async isValid() {
      const flowValidation = await Promise.all([
        this.validateForm('flow-part-1')
      ]);

      if (flowValidation.some((step) => !step)) {
        return false;
      }
      if (this.showDistribution && this.isDistributionRequired && !this.wizardData.haveSubjects) {
        this.error.message = 'Debes agregar la distribución de este documento';
        return false;
      }
      if (!this.step.steps.length) {
        this.error.message = 'Debes agregar al menos un paso';
        return false;
      }

      if (this.step.steps[this.step.steps.length - 1].rolType === this.rolTypes.REVIEWER) {
        this.error.message = 'El último paso no puede ser revisor';
        return false;
      }
      if (this.step.steps.length && this.step.steps[0].stepType === StepTypes.OFFICE) {
        this.error.message = 'Oops! No puedes agregar una oficina como primer paso';
        return false;
      }

      const officeId = (this.step.steps
        .find((step) => step.stepType === this.stepTypes.OFFICE) || {}).responsibleId;

      const hasSigner = this.step.steps.some(
        (step) => step.rolType === this.rolTypes.SIGNER && step.stepType !== StepTypes.OFFICE
      );

      if (this.wizardData.fileCategory === 'numOf' && !hasSigner) {
        this.error.message = 'No se puede realizar las acciones de la oficina sin un paso de rol firmante';
        return false;
      }

      if (this.wizardData.fileCategory === 'int' && !hasSigner) {
        this.error.message = 'No se puede enviar a flujo sin un paso de rol firmante';
        return false;
      }

      if ((this.wizardData.fileCategory === 'numInt'
        || this.wizardData.fileCategory === 'numOf') && !officeId) {
        this.error.message = 'Debes ingresar una oficina en los pasos para el flujo';
        return false;
      }

      if (officeId) {
        if (!this.wizardData.document) {
          this.error.message = 'No es posible encontrar configuración '
            + 'de numeración para este documento';
          return false;
        }

        this.searchingConfig = true;
        const document = this.documents.find((doc) => doc.opcionId === this.wizardData.document);
        const { data: { configFolios = [] } } = await getSheetsConfig({
          tipoDocId: document.opcionId,
          alcanceId: officeId
        });

        this.searchingConfig = false;
        if (!configFolios.length) {
          this.error.message = 'No existe configuración de numeración para este documento';
        }
        return configFolios.length;
      }

      return true;
    },
    getStepData() {
      let document = this.documents.find((doc) => doc.opcionId === this.wizardData.document);
      if (document) {
        document = {
          ...document,
          extra: JSON.parse(document.extra)
        };
      }

      const isResolution = document && document.extra.uso && document.extra.uso.tramite;
      const isControlResolution = document && document.extra.uso && document.extra.uso.contraloria;
      const typeFile = this.wizardData.documentTypeValue || this.wizardData.documentTypeName;

      return {
        isGore: this.isGore,
        isInh: this.isInh,
        fileNumber: this.wizardData.fileNumber,
        fileUrl: this.wizardData.fileUrl,
        fileName: this.wizardData.fileName,
        typeFlowId: this.wizardData.fileType,
        typeFlowText: `${ this.wizardData.fileType } - `,
        fileType: this.wizardData.fileType,
        number: this.wizardData.fileNumber,
        // TODO: mover al mapper. @lettunia
        privado: 'N',
        typeFileDescription: typeFile,
        isResolution,
        isControlResolution,
        ...this.step
      };
    },
    onSetSignaturePositionChange(newValue) {
      this.$emit('update-steps');
      this.$emit('loaded');

      if (!newValue) {
        this.step.signaturesDropped = {};
        this.removeSignaturesDropped();
      }
    }
  },
  async created() {
    this.setDocumentInfo({});
    this.step.name = this.wizardData.fileResumen;
    this.step.mainFile.path = this.wizardData.fileUrl;
    this.step.mainFile.name = this.wizardData.fileName;
    this.step.haveSubjects = this.wizardData.haveSubjects;
    this.step.private = this.step.private || this.wizardData.fileApproach === '2' || this.wizardData.fileApproach === 2;
    await this.getWorkerData({
      tipoRespuesta: 2, // Hay 1 y 2
      elementoId: this.currentUser.id,
      referenciaId: this.company.id,
      filtros: 'nombre:OFICINA_INT,OFICINA_EXT'
    });
    const { data: { opciones } } = await listOptions({
      grupoOpcion: 'tipos.documentos-ed',
      deshabilitado: 'no',
      agrupar: 'si'
    });
    await this.saveDocumentsList(opciones);
    if (this.wizardData.documentValue === 'OFCORE') {
      this.step.name = this.wizardData.fileName;
      this.step.description = this.wizardData.matter;
    }
    if (this.wizardData.documentType) {
      const opcion = opciones.find((item) => item.opcionId === this.wizardData.documentType);
      if (opcion) {
        try {
          opcion.extra = JSON.parse(opcion.extra);
        } catch (e) {
          console.error('cant parse extra data', e);
        }
        this.setDocumentInfo(opcion);
      }
    }
  },
  async mounted() {
    await this.fetchUserGroups();
  }
};
</script>
<style>

.step-wrapper {
  border: 1px solid #662483;
  padding: 10px;
  border-radius: 5px;
  position: relative;
  margin-top: 20px;
}

.step-number {
  position: absolute;
  top: -10px;
  left: -4px;
  padding: 2px 8px;
  background: #16c86b;
  border-radius: 50%;
  color: white;
  font-size: 12px;
}

.step-delete {
  position: absolute;
  top: -10px;
  right: -4px;
  font-size: 10px;
  color: #b11e0b;
  cursor: pointer;
}

.step-rol {
  position: absolute;
  bottom: -10px;
  right: -1px;
  padding: 2px 8px;
  background: #671e85;
  border-radius: 5px;
  color: white;
  font-size: 12px;
}

.step-type {
  position: absolute;
  bottom: -10px;
  left: -1px;
  padding: 2px 8px;
  background: #155f87;
  border-radius: 5px;
  color: white;
  font-size: 12px;
}

.step-name {
  padding: 8px 0;
}
</style>
